import { images } from 'images'

export const mapThirtyFiveMillionDownloadsImage = (lang: string) => {
  switch (lang) {
    case 'de':
      return images.laurel_DE
    case 'en':
      return images.laurel_EN
    case 'fr':
      return images.laurel_FR
    case 'es':
      return images.laurel_ES
    case 'pt':
      return images.laurel_PT
    case 'it':
      return images.laurel_IT
    default:
      throw new Error(
        `ThirtyFiveMillionDownloadsImage not found for language ${lang}`
      )
  }
}

export const mapOnboardingFinishedImage = (lang: string) => {
  switch (lang) {
    case 'de':
      return images.onboardingFinished_DE
    case 'en':
      return images.onboardingFinished_EN
    case 'fr':
      return images.onboardingFinished_FR
    case 'es':
      return images.onboardingFinished_ES
    case 'pt':
      return images.onboardingFinished_PT
    case 'it':
      return images.onboardingFinished_IT
    default:
      throw new Error(
        `OnboardingFinishedImage not found for language ${lang}`
      )
  }
}

export const mapGoogleBadgeImage = (lang: string) => {
  switch (lang) {
    case 'de':
      return images.GoogleBadge_DE
    case 'en':
      return images.GoogleBadge_EN
    case 'fr':
      return images.GoogleBadge_FR
    case 'es':
      return images.GoogleBadge_ES
    case 'pt':
      return images.GoogleBadge_PT
    case 'it':
      return images.GoogleBadge_IT
    default:
      throw new Error(
        `GoogleBadgeImage not found for language ${lang}`
      )
  }
}

export const mapAppleBadgeImage = (lang: string) => {
  switch (lang) {
    case 'de':
      return images.AppleBadge_DE
    case 'en':
      return images.AppleBadge_EN
    case 'fr':
      return images.AppleBadge_FR
    case 'es':
      return images.AppleBadge_ES
    case 'pt':
      return images.AppleBadge_PT
    case 'it':
      return images.AppleBadge_IT
    default:
      throw new Error(
        `AppleBadgeImage not found for language ${lang}`
      )
  }
}

export const mapNumber1AppImage = (lang: string) => {
  switch (lang) {
    case 'de':
      return images.number1App_DE
    case 'en':
      return images.number1App_EN
    case 'fr':
      return images.number1App_FR
    case 'es':
      return images.number1App_ES
    case 'pt':
      return images.number1App_PT
    case 'it':
      return images.number1App_IT
    default:
      throw new Error(`N1AppImage not found for language ${lang}`)
  }
}

export const mapMoneyBackGuaranteeImage = (lang: string) => {
  switch (lang) {
    case 'de':
      return images.moneyBack_DE
    case 'en':
      return images.moneyBack_EN
    case 'fr':
      return images.moneyBack_FR
    case 'es':
      return images.moneyBack_ES
    case 'pt':
      return images.moneyBack_PT
    case 'it':
      return images.moneyBack_IT
    default:
      throw new Error(`MoneyBackGuaranteeImage not found for language ${lang}`)
  }
}

export const mapScientificMethodImage = (lang: string) => {
  switch (lang) {
    case 'de':
      return images.scientificMethod_DE
    case 'en':
      return images.scientificMethod_EN
    case 'fr':
      return images.scientificMethod_FR
    case 'es':
      return images.scientificMethod_ES
    case 'pt':
      return images.scientificMethod_PT
    case 'it':
      return images.scientificMethod_IT
    default:
      throw new Error(`ScientificMethodImage not found for language ${lang}`)
  }
}

export const mapScientificBenefitChartImage = (lang: string) => {
  switch (lang) {
    case 'de':
      return images.scientificBenefitChart_DE
    case 'en':
      return images.scientificBenefitChart_EN
    case 'fr':
      return images.scientificBenefitChart_FR
    case 'es':
      return images.scientificBenefitChart_ES
    case 'pt':
      return images.scientificBenefitChart_PT
    case 'it':
      return images.scientificBenefitChart_IT
    default:
      throw new Error(`ScientificBenefitChartImage not found for language ${lang}`)
  }
}

export const mapOnboardingFinishedSliderData = (lang: string): Array<{imgSrc: string, altTextKey: string}> => {
  switch (lang) {
    case 'de':
      return [
        {
          imgSrc: images.screenshot01_DE,
          altTextKey: 'altTexts.screenshot01'
        },
        {
          imgSrc: images.screenshot02_DE,
          altTextKey: 'altTexts.screenshot02'
        },
        {
          imgSrc: images.screenshot03_DE,
          altTextKey: 'altTexts.screenshot03'
        },
        {
          imgSrc: images.screenshot04_DE,
          altTextKey: 'altTexts.screenshot04'
        },
        {
          imgSrc: images.screenshot05_DE,
          altTextKey: 'altTexts.screenshot05'
        },
        {
          imgSrc: images.screenshot06_DE,
          altTextKey: 'altTexts.screenshot06'
        }
      ]
    case 'en':
      return [
        {
          imgSrc: images.screenshot01_EN,
          altTextKey: 'altTexts.screenshot01'
        },
        {
          imgSrc: images.screenshot02_EN,
          altTextKey: 'altTexts.screenshot02'
        },
        {
          imgSrc: images.screenshot03_EN,
          altTextKey: 'altTexts.screenshot03'
        },
        {
          imgSrc: images.screenshot04_EN,
          altTextKey: 'altTexts.screenshot04'
        },
        {
          imgSrc: images.screenshot05_EN,
          altTextKey: 'altTexts.screenshot05'
        },
        {
          imgSrc: images.screenshot06_EN,
          altTextKey: 'altTexts.screenshot06'
        }
      ]
    case 'fr':
      return [
        {
          imgSrc: images.screenshot01_FR,
          altTextKey: 'altTexts.screenshot01'
        },
        {
          imgSrc: images.screenshot02_FR,
          altTextKey: 'altTexts.screenshot02'
        },
        {
          imgSrc: images.screenshot03_FR,
          altTextKey: 'altTexts.screenshot03'
        },
        {
          imgSrc: images.screenshot04_FR,
          altTextKey: 'altTexts.screenshot04'
        },
        {
          imgSrc: images.screenshot05_FR,
          altTextKey: 'altTexts.screenshot05'
        },
        {
          imgSrc: images.screenshot06_FR,
          altTextKey: 'altTexts.screenshot06'
        }
      ]
    case 'es':
      return [
        {
          imgSrc: images.screenshot01_ES,
          altTextKey: 'altTexts.screenshot01'
        },
        {
          imgSrc: images.screenshot02_ES,
          altTextKey: 'altTexts.screenshot02'
        },
        {
          imgSrc: images.screenshot03_ES,
          altTextKey: 'altTexts.screenshot03'
        },
        {
          imgSrc: images.screenshot04_ES,
          altTextKey: 'altTexts.screenshot04'
        },
        {
          imgSrc: images.screenshot05_ES,
          altTextKey: 'altTexts.screenshot05'
        },
        {
          imgSrc: images.screenshot06_ES,
          altTextKey: 'altTexts.screenshot06'
        }
      ]
    case 'pt':
      return [
        {
          imgSrc: images.screenshot01_PT,
          altTextKey: 'altTexts.screenshot01'
        },
        {
          imgSrc: images.screenshot02_PT,
          altTextKey: 'altTexts.screenshot02'
        },
        {
          imgSrc: images.screenshot03_PT,
          altTextKey: 'altTexts.screenshot03'
        },
        {
          imgSrc: images.screenshot04_PT,
          altTextKey: 'altTexts.screenshot04'
        },
        {
          imgSrc: images.screenshot05_PT,
          altTextKey: 'altTexts.screenshot05'
        },
        {
          imgSrc: images.screenshot06_PT,
          altTextKey: 'altTexts.screenshot06'
        }
      ]
    case 'it':
      return [
        {
          imgSrc: images.screenshot01_IT,
          altTextKey: 'altTexts.screenshot01'
        },
        {
          imgSrc: images.screenshot02_IT,
          altTextKey: 'altTexts.screenshot02'
        },
        {
          imgSrc: images.screenshot03_IT,
          altTextKey: 'altTexts.screenshot03'
        },
        {
          imgSrc: images.screenshot04_IT,
          altTextKey: 'altTexts.screenshot04'
        },
        {
          imgSrc: images.screenshot05_IT,
          altTextKey: 'altTexts.screenshot05'
        },
        {
          imgSrc: images.screenshot06_IT,
          altTextKey: 'altTexts.screenshot06'
        }
      ]
    default:
      throw new Error(`SliderImages not found for language ${lang}`)
  }
}
